// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"338":"c15599c0","787":"c6006e9a"}[chunkId] + ".chunk.js";
};